import React, { MutableRefObject } from "react";
import { useDispatch } from "react-redux";

import { UploadFileButton } from "../../../../../components";
import { fileParser } from "../../../urlFilters.actions";

import "./UploadCsvFileButton.scss";

interface UploadCsvFileButtonProps {
  buttonRef: MutableRefObject<HTMLButtonElement>;
}

export const UploadCsvFileButton = ({
  buttonRef,
}: UploadCsvFileButtonProps) => {
  const dispatch = useDispatch();
  const handleFileUpload = ({
    currentTarget: { files, value },
  }: React.FormEvent<HTMLInputElement>) =>
    dispatch(fileParser(files[0], value));

  return (
    <UploadFileButton
      ref={buttonRef}
      className="upload-csv-file-button"
      filetypes=".csv,text/csv"
      onChange={handleFileUpload}
    />
  );
};
